import { Box, Typography } from "@material-ui/core";
import { NewsType } from "./ElectricityAnalysisSection/SwyftNews/SwyftNews.constants";

export const News = ({
  data,
  isCenter,
  isWhiteText,
  isMinHeight = true
}: {
  data: NewsType;
  isCenter?: boolean;
  isWhiteText?: boolean;
  isMinHeight?: boolean;
}): JSX.Element => {
  return (
    <Box
      display="flex"
      flexDirection="column"
      height="100%"
      alignItems={isCenter ? "center" : "initial"}
      minHeight={{ xs: isMinHeight ? 580 : "auto", md: "auto" }}
    >
      <Box maxWidth={510} width="100%" mb={4}>
        <img
          loading="lazy"
          src={data.src}
          alt={data.title}
          style={{ width: "100%", height: "auto", display: "block" }}
        />
      </Box>

      <Box mb={4} maxWidth={280} textAlign={isCenter ? "center" : "initial"}>
        {data.title && (
          <Box mb={2}>
            <Typography variant="h2" style={{ color: "#1e073f" }} color={isWhiteText ? "initial" : "primary"}>
              {data.title}
            </Typography>
          </Box>
        )}
        <Box mb={2}>
          <Typography
            variant="h3"
            style={{ fontWeight: 200 }}
            className={isWhiteText ? "whiteText" : ""}
            color={isWhiteText ? "initial" : "primary"}
          >
            {data.content}
          </Typography>
        </Box>

        {data.subContent && (
          <Box>
            <Typography
              variant="h6"
              style={{ fontWeight: 200 }}
              className={`${isWhiteText ? "whiteText" : ""} font-extralight`}
              color={isWhiteText ? "initial" : "secondary"}
            >
              {data.subContent}
            </Typography>
          </Box>
        )}
      </Box>

      <Box width={237} maxWidth="100%" mt={{ xs: 0, md: "auto" }}></Box>
    </Box>
  );
};
